import { IconProps } from '@models/icons';

function SocialYoutubeIcon({ size = 16, color }:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd"
                d="M8.83333 3C5.33553 3 2.5 5.83553 2.5 9.33333V15.6667C2.5 19.1645 5.33553 22 8.83333 22H15.1667C18.6645 22 21.5 19.1645 21.5 15.6667V9.33333C21.5 5.83553 18.6645 3 15.1667 3H8.83333ZM16.9485 8.33124C17.4946 8.47761 17.9238 8.90687 18.0688 9.45153C18.3334 10.4395 18.3334 12.5 18.3334 12.5C18.3334 12.5 18.3334 14.5604 18.0688 15.5484C17.9224 16.0945 17.4931 16.5223 16.9485 16.6687C15.9605 16.9333 12.0001 16.9333 12.0001 16.9333C12.0001 16.9333 8.03963 16.9333 7.05163 16.6687C6.50556 16.5223 6.0763 16.0931 5.93134 15.5484C5.66675 14.5604 5.66675 12.5 5.66675 12.5C5.66675 12.5 5.66675 10.4395 5.93134 9.45153C6.07771 8.90546 6.50697 8.47761 7.05163 8.33124C8.03963 8.06665 12.0001 8.06665 12.0001 8.06665C12.0001 8.06665 15.9605 8.06665 16.9485 8.33124ZM14.0239 12.5L10.7334 10.6V14.4L14.0239 12.5Z"
                fill={color}/>
        </svg>
    );
}

export default SocialYoutubeIcon;
